<!-- Input Radio Button Template -->
<ng-template #input_radio_button_template>
  <div class="flex align-items-center p-2 h-full">
    @if (model !== undefined) {
      <p-radioButton inputId="{{ name }}"
        ariaLabelledBy="{{ name }}_label"
        styleClass="{{ inputClass }}"
        [disabled]="disabled"
        [name]="name"
        [ngModel]="model"
        [ngModelOptions]="{standalone: true}"
        [value]="value"
        (onClick)="valueChange.emit($event)">
      </p-radioButton>
    }
    @if (!labelTop && label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1 ml-2"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
  </div>
</ng-template>
<!-- Switch Input -->
<div class="w-full"
     [class.field]="formField">
  @if (labelTop && label) {
    <label
      id="{{ name }}_label"
      class="flex flex-grow-1"
      [class.mb-2]="!formField"
      for="{{ name }}">
      <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
        {{ label | translate }}
      </span>
    </label>
  }
  @if (!inputGroup) {
    <ng-container *ngTemplateOutlet="input_radio_button_template"></ng-container>
  } @else {
    <div medsurf-design-content-input-group>
      <ng-container *ngTemplateOutlet="input_radio_button_template"></ng-container>
      <ng-content></ng-content>
    </div>
  }
</div>
